<script lang="ts" setup>
import SBLogo from '@assets/icons/SBLogo.vue';
import SPLogo from '@assets/icons/SPLogo.vue';
import { useClaims } from '@auth/useClaims';
import VSizeContainer from '@shared/layout/VSizeContainer/VSizeContainer.vue';
import { useRouter } from 'vue-router';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import VHeading from '@shared/typography/VHeading/VHeading.vue';

defineProps<{
  title?: string;
  subTitle?: string;
  description?: string;
  showReload?: boolean;
}>();

const router = useRouter();
const claims = useClaims();
function reload() {
  window.location.reload();
}
</script>

<template>
  <VSizeContainer size="sm">
    <VContentBox class="m-4">
      <div class="flex flex-row justify-center">
        <component
          :is="claims?.isParticulier ? SPLogo : SBLogo"
          class="h-[100px]"
          role="img"
          :aria-label="claims?.isParticulier ? 'SUREprivate' : 'SUREbusiness'"
        />
        <div class="ml-4 flex flex-col">
          <div class="flex flex-col">
            <VHeading :level="1">{{ title }}</VHeading>
            <VHeading :level="2">{{ subTitle }}</VHeading>
            <small class="pt-2">{{ description }}</small>
          </div>

          <nav class="mt-6 flex flex-col leading-10">
            <span v-if="showReload">
              <FontAwesomeIcon icon="fa-solid fa-rotate-right" class="mr-2 text-primary" />
              <a class="cursor-pointer" @click="reload()">Opnieuw proberen</a>
            </span>
            <span>
              <FontAwesomeIcon icon="fa-solid fa-hand-point-left" class="mr-2 text-primary" />
              <a class="cursor-pointer" @click="router.go(-1)">Vorige pagina</a>
            </span>
            <span>
              <FontAwesomeIcon icon="fa-solid fa-home-lg-alt" class="mr-2 text-primary" />
              <RouterLink to="/">Terug naar de homepage</RouterLink>
            </span>
          </nav>
        </div>
      </div>
    </VContentBox>
  </VSizeContainer>
</template>
